export const KLARNA_LOGO_URL = 'https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/vector/klarna-logo.svg';
